import Vue from "vue";

export const apiFile = async (url, { ...data }) => {
  return await Vue.axios
    .get(url, { responseType: "blob", params: { ...data } })
    .then(response => {
      let anchor = document.createElement("a");
      document.body.appendChild(anchor);
      let objectUrl = window.URL.createObjectURL(response.data);
      anchor.href = objectUrl;
      anchor.target = "_blank";
      anchor.download = response.headers["content-disposition"].split(
        "filename="
      )[1];
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    })
    .catch(error => {
      throw error;
    });
};
